// FETCH ALL PROPERTIES FROM KNITTING_INWARD DETAILS
export const FETCH_KNITTING_INWARD_DETAILS_REQUEST = 'FETCH_KNITTING_INWARD_DETAILS_REQUEST';
export const FETCH_KNITTING_INWARD_DETAILS_SUCCESS = 'FETCH_KNITTING_INWARD_DETAILS_SUCCESS';
export const FETCH_KNITTING_INWARD_DETAILS_FAILURE = 'FETCH_KNITTING_INWARD_DETAILS_FAILURE';

// FETCH ALL PROPERTIES FROM KNITTING_INWARD DETAILS BY ID
export const FETCH_KNITTING_INWARD_DETAILS_BY_ID_REQUEST = 'FETCH_KNITTING_INWARD_DETAILS_BY_ID_REQUEST';
export const FETCH_KNITTING_INWARD_DETAILS_BY_ID_SUCCESS = 'FETCH_KNITTING_INWARD_DETAILS_BY_ID_SUCCESS';
export const FETCH_KNITTING_INWARD_DETAILS_BY_ID_FAILURE = 'FETCH_KNITTING_INWARD_DETAILS_BY_ID_FAILURE';

// FETCH ALL PROPERTIES FROM KNITTING_INWARD DETAILS
export const FETCH_PREVIOUS_KNITTING_INWARD_DETAILS_REQUEST = 'FETCH_PREVIOUS_KNITTING_INWARD_DETAILS_REQUEST';
export const FETCH_PREVIOUS_KNITTING_INWARD_DETAILS_SUCCESS = 'FETCH_PREVIOUS_KNITTING_INWARD_DETAILS_SUCCESS';
export const FETCH_PREVIOUS_KNITTING_INWARD_DETAILS_FAILURE = 'FETCH_PREVIOUS_KNITTING_INWARD_DETAILS_FAILURE';

// CREATE PROPERTIES FOR KNITTING_INWARD DETAILS
export const CREATE_KNITTING_INWARD_DETAILS_REQUEST = 'CREATE_KNITTING_INWARD_DETAILS_REQUEST';
export const CREATE_KNITTING_INWARD_DETAILS_SUCCESS = 'CREATE_KNITTING_INWARD_DETAILS_SUCCESS';
export const CREATE_KNITTING_INWARD_DETAILS_FAILURE = 'CREATE_KNITTING_INWARD_DETAILS_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_KNITTING_INWARD_DETAILS = 'CREATE_USER_FORM_KNITTING_INWARD_DETAILS';

// UPDATE PROPERTIES FOR KNITTING_INWARD DETAILS
export const UPDATE_KNITTING_INWARD_DETAILS_REQUEST = 'UPDATE_KNITTING_INWARD_DETAILS_REQUEST';
export const UPDATE_KNITTING_INWARD_DETAILS_SUCCESS = 'UPDATE_KNITTING_INWARD_DETAILS_SUCCESS';
export const UPDATE_KNITTING_INWARD_DETAILS_FAILURE = 'UPDATE_KNITTING_INWARD_DETAILS_FAILURE';

// FETCH SINGLE KNITTING_INWARD_DETAILS
export const FETCH_SINGLE_KNITTING_INWARD_DETAILS_REQUEST = 'FETCH_SINGLE_KNITTING_INWARD_DETAILS_REQUEST';
export const FETCH_SINGLE_KNITTING_INWARD_DETAILS_SUCCESS = 'FETCH_SINGLE_KNITTING_INWARD_DETAILS_SUCCESS';
export const FETCH_SINGLE_KNITTING_INWARD_DETAILS_FAILURE = 'FETCH_SINGLE_KNITTING_INWARD_DETAILS_FAILURE';

// DELETE PROPERTIES FOR KNITTING_INWARD DETAILS
export const DELETE_KNITTING_INWARD_DETAILS_REQUEST = 'DELETE_KNITTING_INWARD_DETAILS_REQUEST';
export const DELETE_KNITTING_INWARD_DETAILS_SUCCESS = 'DELETE_KNITTING_INWARD_DETAILS_SUCCESS';
export const DELETE_KNITTING_INWARD_DETAILS_FAILURE = 'DELETE_KNITTING_INWARD_DETAILS_FAILURE';

export const FETCH_KNITTING_INWARD_DETAILS_SO_AND_SN_REQUEST = 'FETCH_KNITTING_INWARD_DETAILS_SO_AND_SN_REQUEST';
export const FETCH_KNITTING_INWARD_DETAILS_SO_AND_SN_SUCCESS = 'FETCH_KNITTING_INWARD_DETAILS_SO_AND_SN_SUCCESS';
export const FETCH_KNITTING_INWARD_DETAILS_SO_AND_SN_FAILURE = 'FETCH_KNITTING_INWARD_DETAILS_SO_AND_SN_FAILURE';

// USERFORM RESET

export const KNITTING_INWARD_DETAILS_USERFORM_RESET = 'KNITTING_INWARD_DETAILS_USERFORM_RESET';

export const KNITTING_INWARD_DETAILS_PO_DETAILS_DISABLED = 'KNITTING_INWARD_DETAILS_PO_DETAILS_DISABLED';
